import { render, staticRenderFns } from "./ControlTime.vue?vue&type=template&id=c6e21b52"
import script from "./ControlTime.vue?vue&type=script&lang=js"
export * from "./ControlTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports